var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoLicence(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 0.699707C3.1865 0.699707 0.5 3.38621 0.5 6.69971C0.5 10.014 3.1865 12.6997 6.5 12.6997C9.8135 12.6997 12.5 10.014 12.5 6.69971C12.5 3.38621 9.8135 0.699707 6.5 0.699707ZM4.78033 3.91967C4.48744 3.62678 4.01256 3.62678 3.71967 3.91967C3.42678 4.21257 3.42678 4.68744 3.71967 4.98033L5.43934 6.7L3.71967 8.41967C3.42678 8.71257 3.42678 9.18744 3.71967 9.48033C4.01256 9.77323 4.48744 9.77323 4.78033 9.48033L6.5 7.76066L8.21967 9.48033C8.51256 9.77323 8.98744 9.77323 9.28033 9.48033C9.57322 9.18744 9.57322 8.71257 9.28033 8.41967L7.56066 6.7L9.28033 4.98033C9.57322 4.68744 9.57322 4.21257 9.28033 3.91967C8.98744 3.62678 8.51256 3.62678 8.21967 3.91967L6.5 5.63934L4.78033 3.91967Z",
    fill: "#032339"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLicence);
export default __webpack_public_path__ + "static/media/noLicence.ecf8aba2252806e4eafd6df0a8007b39.svg";
export { ForwardRef as ReactComponent };